import type { Store } from '@reduxjs/toolkit'
import type { EcrmSessionRootState } from './types'

let _store: Store<EcrmSessionRootState> | null = null

/**
 * Call once after `createStore` (e.g. from the app’s `store.ts`) so session helpers
 * can read/dispatch without importing app-specific store modules.
 */
export function configureSessionPolicyStore<S extends EcrmSessionRootState>(
  store: Store<S>
): void {
  _store = store as unknown as Store<EcrmSessionRootState>
}

export function getSessionPolicyStore(): Store<EcrmSessionRootState> {
  if (!_store) {
    throw new Error(
      'configureSessionPolicyStore must be called before session policy code runs'
    )
  }
  return _store
}
